export enum CallAnalysisTab {
  OVERVIEW = 0,
  MARKET = 1,
  PATTERNS = 2,
}
